/**
 * Netfabb Download Server AutoHandler
 *
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

$(document).ready(function() {
  $('body').on('change', '[data-sw-netfabb-download-server]', function() {
    var $el = $(this);
    sw.setSetting("netfabbDownloadServer", $el.val());
  });
});
